import { FunctionComponent } from "react";

import { classNames } from "@/utils/classNames";

import { List } from "../../schema/list";
import { Tabs } from "./unassignedTabs";
import { TabCountChips } from "./TabCountChips";

interface ListStatusTabStripProps {
	tabs: { label: string; value: Tabs }[];
	currentTab: Tabs;
	list?: List;
	unsureCount: number;
	onTabChange: (tab: Tabs) => void;
}

/** Level-2 status tab strip for the list-detail page (Unassigned / Saved / Assigned / …). */
export const ListStatusTabStrip: FunctionComponent<ListStatusTabStripProps> = ({
	tabs,
	currentTab,
	list,
	unsureCount,
	onTabChange,
}) => (
	<div className="flex items-center h-[34px] px-2 bg-white border-b border-border-light overflow-x-auto">
		{tabs.map((tab) => {
			const isActive = currentTab === tab.value;

			return (
				<button
					key={tab.value}
					className={classNames(
						"cursor-pointer flex items-center gap-1.5 h-[32px] px-3 text-xs whitespace-nowrap border-b-2 -mb-px transition-colors",
						isActive
							? "text-text font-semibold border-blue-action"
							: "text-text-meta font-medium border-transparent hover:text-text"
					)}
					type="button"
					onClick={() => onTabChange(tab.value)}
				>
					<span>{tab.label}</span>
					<TabCountChips
						isActive={isActive}
						list={list}
						tab={tab.value}
						unsureCount={unsureCount}
					/>
				</button>
			);
		})}
	</div>
);
